// Imports ------------------------------------------------------------------->

import {Component, attr} from "../Component";
import {element} from "../CustomElement";

import {Page} from "../flipp-page/Page";
import {inject} from "../../services/di";
import {FlyerService} from "../../services/FlyerService";
import {FlyerDetails, Flyer} from "../../definitions/FlyerDefinitions";
import {LinkService} from "../../services/LinkService";
import {ConfigService, RuntimeConfig} from "../../services/ConfigService";
import {isCrawler} from "../../utils/crawler";

// Private Definitions ------------------------------------------------------->

interface NativeLandingProps extends JSX.HTMLProps {
	flyerId?: number;
	flyerRunId?: number;
	merchantId?: number;
}

// Public Definitions -------------------------------------------------------->

/* Dummy component which acts as the entry point for native distribution. The router
	* renders this component so that we can show some UI while the flyer data is being fetched.
	* Once fetched, we simply redirect the user to the appropriate flyer or the 404 page
	*/
@element("flipp-native-landing")
export class NativeLanding extends Component<NativeLandingProps, {}> {
	@attr flyerId: number;
	@attr flyerRunId: number;
	@attr merchantId: number;

	@inject flyerService: FlyerService;
	@inject linkService: LinkService;
	@inject configService: ConfigService;

	prepare() {
		// TODO: in case when flyer by passed id param not found should be used general approach
		if (this.configService.RUNTIME === RuntimeConfig.DISTRIBUTION && this.flyerId) {
			return this.flyerService.getFullFlyer(this.flyerId)
				.then(flyerDetails => {
					if (flyerDetails) {
						return flyerDetails;
					}
				});
		}
		return this.flyerService.getFlyers().then((flyers) => {
			// List of flyers matched based on parameters passed
			const foundFlyersList = this.flyerService.getPriorityFlyer(flyers, this.flyerId, this.flyerRunId, this.merchantId);

			// Returns of array of functions that when called return a promise
			const promiseFunctionsArray = foundFlyersList.map(flyer => () => this.flyerService.getFullFlyer(flyer.id));

			// Run promises sequentially and stop running promises (skip them over) whenever one of them succeeds. Keep results of first successful promise.
			// E.g. if you have 3 promises a, b and c
			// a().then(result => result ? result : b()).then(result => result ? result : c()).then(finalResult => { handle results })
			// We use a reduce function to facilitate the above
			return promiseFunctionsArray.reduce(
				(promise, currentFn) => promise.then(result => result ? result : currentFn()), // Reducer
				Promise.resolve(null) // Initial Value. This will be the first promise called which will "fail" (return null)
			).then(flyer => {
				if (!flyer) {
					/* If flyer cannot be found (expired? wrong FSA?) then return an error.*/
					// FIXME: Component framework will not render if promise() returns null, so instead
					// 	we return a string here. Explore implementing renderError support and adopt here
					return "Not found";
				}
				return flyer;
			});
		});
	}

	renderLoading() {
		return this._doRender();
	}

	render() {
		return this._doRender();
	}

	onRender() {
		if (isCrawler()) {
			return;
		}

		const linkBaseParams = {
			// Set link transition to untracked so the /dist entry doesn't appear in browser history
			tracked: false
		};
		if (typeof this.model === "string") {
			this.linkService.execute(this.linkService.linkTo("listing"), this, linkBaseParams);
		} else {
			const flyerDetails = this.model as FlyerDetails;
			this.linkService.execute(this.linkService.linkTo(this.model), this, {
				context: flyerDetails,
				...linkBaseParams
			});
		}
	}

	private _doRender() {
		return <Page show="flyers">
			<div flex-vertical fill-absolute>
				<div class="topbar" flex-vertical flex-shrink>
				</div>
				<section class="main">
					<div class="loading">
						<div class="spinner"></div>
					</div>
				</section>
				<section class="xbrowse"></section>
			</div>
		</Page>;
	}

}
